export default __webpack_public_path__ + "static/media/BCIPA.21c234c1.webp";